import React, { useState, useEffect } from "react";
import {
  Box,
  Stack,
  Typography,
} from "@mui/material";
import CreateForm from "./CreateForm";
import ViewForms from "./ViewForms";
import CustomTabs from "../../common/custom-tabs";
import { ColorsConstants } from "../../cssUtils/constants";

const TabPanel = ({ children, value, index }) => (
  <div hidden={value !== index} style={{ height: "100%" }}>
    {value === index && <Box sx={{ height: "100%" }}>{children}</Box>}
  </div>
);

const FormsManagement = (props) => {
  // Get the tab from pageParams, default to 1 (View Forms)
  const initialTab = props.pageParams?.tab ?? 1;
  const [activeTab, setActiveTab] = useState(initialTab);

  // Update active tab when pageParams changes
  useEffect(() => {
    if (props.pageParams?.tab !== undefined) {
      setActiveTab(props.pageParams.tab);
    }
  }, [props.pageParams?.tab]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    // Clear any tab param when manually switching tabs
    if (props.onNavigate) {
      props.onNavigate("whatsapp_forms", { tab: newValue });
    }
  };

  const tabs = [
    { label: "Create Form", value: 0 },
    { label: "View Forms", value: 1 },
  ];

  return (
    <Stack sx={{ height: "100%", backgroundColor: "#FAFAFA" }}>
      {/* Custom Tabs */}
      <Box sx={{ px: 3, py: 2, width: "50%" }}>
        <CustomTabs
          value={activeTab}
          onChange={handleTabChange}
          tabs={tabs}
         
        
        />
      </Box>

      {/* Tab Content */}
      <Box sx={{ flex: 1, overflow: "auto", p: 3 }}>
        <TabPanel value={activeTab} index={0}>
          <CreateForm 
            onNavigate={props.onNavigate} 
            pageParams={props.pageParams} 
          />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <ViewForms 
            onNavigate={props.onNavigate} 
            pageParams={props.pageParams} 
          />
        </TabPanel>
      </Box>
    </Stack>
  );
};

export default FormsManagement;